/**
 * @author jakubmaslon
 * @since 2021-9-8
 */

import * as React from "react";
import { useTheme } from "styled-components";

import { CREDIT_CARDS_PROVIDERS } from "@typings/payments";

import { MasterCard, Amex, Visa, PostePay } from "@ui/Assets/PaymentProviders";

interface Props {
  availableCreditCardsProviders: CREDIT_CARDS_PROVIDERS[];
}

const creditCardsComponents = {
  [CREDIT_CARDS_PROVIDERS.AMEX]: Amex,
  [CREDIT_CARDS_PROVIDERS.VISA]: Visa,
  [CREDIT_CARDS_PROVIDERS.MASTERCARD]: MasterCard,
  [CREDIT_CARDS_PROVIDERS.POSTEPAY]: PostePay,
};

/**
 * @deprecated please use the CreditCardsLogosV2 component instead
 */
const CreditCardsLogos = (props: Props): React.ReactElement => {
  const theme = useTheme();

  const ccStyle = {
    minWidth: theme.fonts.sizes.h5,
    height: theme.fonts.sizes.body2,
    marginLeft: theme.margins.base,
  };

  return (
    <React.Fragment>
      {props.availableCreditCardsProviders.map(creditCardProvider => {
        const CreditCardProviderLogo =
          creditCardsComponents[creditCardProvider];

        return (
          <CreditCardProviderLogo key={creditCardProvider} style={ccStyle} />
        );
      })}
    </React.Fragment>
  );
};

CreditCardsLogos.displayName = "CreditCardsLogos";

export { CreditCardsLogos };
